export enum EVALUATION_METRICS {
  HUMUS = "humus",
  SOC = "soc",
  CO2 = "co2",
}

export const EVALUATION_METRICS_UNIT_OF_MEASURE = {
  [EVALUATION_METRICS.HUMUS]: "%",
  [EVALUATION_METRICS.SOC]: "t",
  [EVALUATION_METRICS.CO2]: "t",
};
